import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface GivingTotals {
  total_amount: number;
  washington_amount: number;
  union_amount: number;
  entry_count: number;
}

export const useGivingTotals = () => {
  const [data, setData] = useState<GivingTotals | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchTotals = async () => {
    const { data: rows, error } = await supabase.rpc("get_giving_totals");
    if (!error && rows && rows.length > 0) {
      const r = rows[0];
      setData({
        total_amount: Number(r.total_amount) || 0,
        washington_amount: Number(r.washington_amount) || 0,
        union_amount: Number(r.union_amount) || 0,
        entry_count: Number(r.entry_count) || 0,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTotals();
  }, []);

  return { data, loading, refetch: fetchTotals };
};

export const formatCurrency = (amount: number, compact = false): string => {
  if (compact && amount >= 1000) {
    return `$${(amount / 1000).toFixed(amount >= 10000 ? 0 : 1)}k`;
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(amount);
};
